import React, { useState, useEffect, useRef } from 'react';
import { Button, Table, Spin, Form, Input, Select, Tabs, Space, InputNumber } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, SearchOutlined, RedoOutlined, HomeOutlined, PlusCircleOutlined, EditOutlined, DeleteOutlined, EyeOutlined } from '@ant-design/icons';
import PopupFrame from '../../component/popupFrame/popupFrame';//删除弹框
import Audit from '../../component/audit/audit';//审核彈框
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import { ContextHandler } from '../../public/js/contextHandler';
import context from '../../public/js/context';
import RoleFromModal from './roleFromModal';
import trans from './translation';
import Message from '../../component/message/message';
import './sysUser.css';
import SelectProgrammeModal from './selectProgrammeModal';

const { TabPane } = Tabs;
const { Option } = Select;

const SysUser = (props) => {

    const messageRef = useRef();
    const [form] = Form.useForm();
    const userType = Form.useWatch('userType', form);
    const [form2] = Form.useForm();
    const [isLoad, setIsLoad] = useState(false);
    const [spinInfo, setSpinInfo] = useState("");
    const [isAudit, setIsAudit] = useState(false);
    const [auditModel, setAuditModel] = useState({});
    const [tabIndex, setTabIndex] = useState("1");
    const [searchModel, setSearchModel] = useState({});
    const [oldSearchModel, setOldSearchModel] = useState({});
    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [checkboxState, setCheckboxState] = useState([]);
    const [isDeleteFrame, setIsDeleteFrame] = useState(false);
    const [flag, setFlag] = useState("");
    const [sysUserRoleList, setSysUserRoleList] = useState([]);
    const [roleModel, setRoleModel] = useState({});
    const [sysRoleSelectedRowKeys, setSysRoleSelectedRowKeys] = useState([]);
    const [sysRoleCheckboxState, setSysRoleCheckboxState] = useState([]);
    const [deleteFlag, setDeleteFlag] = useState("");
    const [isRoleFrom, setIsRoleFrom] = useState(false);
    const [userRoleModel, setUserRoleModel] = useState("");
    const [deleteTipText, setDeleteTipText] = useState("");
    const [programmeTable, setProgrammeTable] = useState([]);
    const [isProgrammeModal, setIsProgrammeModal] = useState(false);
    const [isProgrammeDeleteModal, setIsProgrammeDeleteModal] = useState(false);
    const [deleteIndex, setDeleteIndex] = useState();
    const [deptList, setDeptList] = useState([]);

    useEffect(() => {
    }, [userType]);

    const tableColumns = {
        userName: "user_code",
        name: "name",
    }

    useEffect(() => {
        searchAllDept();
        search(pageSize, 1, "N");
    }, []);

    const searchAllDept = () => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        Base.callBackApi("commonDropDown/searchAllDept").then((data) => {
            if ("SUCCESS" === data.msg) {
                setDeptList(data.object ?? [])
            } else {
                errFrameShow("error", data.msg);
            }
        })
    }

    const search = (pageSizeNew, currentPageNew, flag, isShowMsg) => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        messageShowHandler();  // 清除提示信息
        clearSelect(); // 清除选中状态
        let model = {};
        if ("Y" === flag) {     // 翻页
            model = oldSearchModel;
        } else {
            model = searchModel;
        }
        model.startRow = (currentPageNew - 1) * pageSizeNew;
        model.pageSize = pageSizeNew;
        setIsLoad(true);
        setSpinInfo(trans.beQuerying[Config.backLang]);
        Base.callBackApi("user/search", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!data?.object?.list && isShowMsg) {
                    errFrameShow("info", trans.noneDate[Config.backLang]);
                }
                if ("N" === flag) {
                    setOldSearchModel(JSON.parse(JSON.stringify(model)));
                }
                setTablesCount(data?.object?.total ?? 0);
                setTables(data?.object?.list ?? []);
                setCurrent(currentPageNew);
                setPageSize(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const searchChange = (key, value) => {
        messageShowHandler();
        setSearchModel(model => {
            return { ...model, ...{ [key]: value } };
        });
    }

    const reset = () => {
        messageShowHandler();
        clearSelect();
        setSearchModel({});
        setOldSearchModel({});
        setTablesCount(0);
        setTables([]);
        setPageSize(10);
    }

    const update = (model, e) => {
        e.stopPropagation();
        messageShowHandler();
        setSelectedRowKeys([model.userId]);
        searchById(model, "edit")
        searchSysUserRoleList(model);
        setTabIndex("2");
    }

    const searchById = (model, flag) => {
        setIsLoad(true);
        setSpinInfo(trans.beQuerying[Config.backLang]);
        Base.callBackApi("user/searchUserInfoById", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                let model = data.object ?? {};
                let programmeList = data.object.programmeList ?? [];
                setProgrammeTable(programmeList);
                setCheckboxState([model]);
                setRoleModel(model);
                setFlag(flag);
                initForm(model)
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const view = (model, e) => {
        e.stopPropagation();
        messageShowHandler();
        setSelectedRowKeys([model.userId]);
        searchById(model, "view")
        searchSysUserRoleList(model);
        setTabIndex("2");
    }

    const updateRole = (model, e) => {
        if (e) {
            e.stopPropagation();
        }
        messageShowHandler();
        setIsLoad(true);
        Base.callBackApi("user/searchUserInfoById", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                let modelTwo = data.object ?? {};
                form2.resetFields();
                form2.setFieldsValue({
                    userId: modelTwo.userId ?? null,
                    userCode: modelTwo.userCode ?? '',
                    userName: modelTwo.userName ?? '',
                    docId: modelTwo.docId ?? '',
                });
                setFlag("edit");
                setTabIndex("3");
                setCheckboxState([modelTwo]);
                setSelectedRowKeys([modelTwo.userId]);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));


    }

    const deleteOne = (model, e) => {
        e.stopPropagation();
        if (model.activeInd !== "N") {
            errFrameShow("error", trans.notDelete[Config.backLang]);
            return;
        }
        setCheckboxState([model]);
        setSelectedRowKeys([model.userId]);
        setDeleteTipText(trans.userCode[Config.backLang] + ":" + model.userCode)
        setIsDeleteFrame(true);
        setDeleteFlag("user");
    }

    // Tab页切换
    const handleSelect = (key) => {
        if (key) {
            if (key === "3") {
                // updateRole();
            } else if (key === "2") {
                if (Config.funcInfo.canInsert === "Y") {
                    add();
                }
            } else if (tabIndex !== "1") {
                cancel();
                search(pageSize, current, "Y");
            }
        }
    }

    const add = () => {
        messageShowHandler();
        setProgrammeTable([])
        initForm({ activeInd: 'Y', userType: 'ADMIN' });
        setFlag("add");
        setTabIndex("2");
    }

    const initForm = (model = {}) => {
        form.resetFields();
        form.setFieldsValue({
            userId: model.userId ?? '',
            userCode: model.userCode ?? '',
            userName: model.userName ?? '',
            pwd: '',
            userType: model.userType ?? '',
            activeInd: model.activeInd ?? '',
            // phone: model.phone ?? '',
            email: model.email ?? '',
            // docId: model.docId ?? '',
        });
    }

    const deleteFrameClose = (state) => {
        if (state) {
            if (deleteFlag === "user") {
                deleteData();
            } else {
                deleteUserRole();
            }
        }
        setIsDeleteFrame(false);
    }

    const checkIdCardNo = (value) => {
        if (value) {
            if (Base.checkIdCardNo(value)) {
                return Promise.resolve();
            }
            return Promise.reject(new Error(trans.errorIDNo[Config.backLang]));
        }
        return Promise.resolve();
    }

    const deleteData = () => {
        setIsLoad(true);
        setSpinInfo(trans.deleteData[Config.backLang]);
        let deleteModel = checkboxState[0];
        deleteModel.menuFuncId = Config.funcInfo.funcId;
        Base.callBackApi("user/delete", deleteModel).then((data) => {
            if ("SUCCESS" === data.msg) {
                search(pageSize, current, "Y", false);
                errFrameShow("success", trans.deleteSuccess[Config.backLang]);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const auditCancel = () => {
        setIsAudit(false);
    }

    /**查询用戶的角色list */
    const searchSysUserRoleList = (model) => {
        clearSysRoleSelect();
        Base.callBackApi("user/searchSysUserRole", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                setSysUserRoleList(data.object ?? []);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => { });
    }

    const onFinish = (values) => {
        if(values.userType === 'LITE_ADMIN') {
            if(Base.isEmpty(programmeTable)) {
                errFrameShow('error', 'For lite admin, programme is required.')
                return
            }
        }
        messageShowHandler();
        setIsLoad(true);
        setSpinInfo(trans.dataBeSaving[Config.backLang])
        let url = "";
        if (flag === "add") {
            url = "user/insert";
        } else {
            url = "user/update"
            values.userId = selectedRowKeys[0];
            values.lastUpdatedDate = checkboxState[0].lastUpdatedDate;
        }
        values.programmeList = programmeTable;
        values.menuFuncId = Config.funcInfo.funcId;
        Base.callBackApi(url, values).then((data) => {
            if ("SUCCESS" === data.msg) {
                let model = data.object;
                searchSysUserRoleList(model)
                setSelectedRowKeys([model.userId]);
                // setCheckboxState([model]);
                // setFlag("edit")
                // initForm(model)
                // setRoleModel(model)
                searchById(model, 'edit')
                errFrameShow("success", trans.saveSuccess[Config.backLang]);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const checkPhone = (value) => {
        if (value) {
            if (/^1[3456879]\d{9}$/.test(value)) {
                return Promise.resolve();
            }
            return Promise.reject(new Error(trans.correctPhone[Config.backLang]));
        }
        return Promise.reject(new Error(trans.phoneIsNoNull[Config.backLang]));
    }

    const onFinish2 = (values) => {
        messageShowHandler();
        setIsLoad(true);
        setSpinInfo(trans.dataBeSaving[Config.backLang])
        values.userId = selectedRowKeys[0];
        values.lastUpdatedDate = checkboxState[0].lastUpdatedDate;
        values.menuFuncId = Config.funcInfo.funcId;
        Base.callBackApi("user/updateDocId", values).then((data) => {
            if ("SUCCESS" === data.msg) {
                updateRole(values)
                errFrameShow("success", trans.saveSuccess[Config.backLang]);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const cancel = () => {
        messageShowHandler();
        clearSelect();
        clearSysRoleSelect();
        setTabIndex("1");
        search(pageSize, current, "Y");
    }

    const deleteUserRole = () => {
        setIsLoad(true);
        setSpinInfo(trans.dataBeSaving[Config.backLang])
        let deleteModel = sysRoleCheckboxState[0];
        deleteModel.menuFuncId = Config.funcInfo.funcId;
        Base.callBackApi("user/deleteUserRole", deleteModel).then((data) => {
            if ("SUCCESS" === data.msg) {
                errFrameShow("success", trans.deleteSuccess[Config.backLang]);
                searchSysUserRoleList(roleModel);//查询用戶角色list
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const sysRoleEdit = (model, e) => {
        messageShowHandler();
        setUserRoleModel(model);
        setIsRoleFrom(true);
    }

    const sysRoleDelete = (model, e) => {
        e.stopPropagation();
        setSysRoleCheckboxState([model]);
        setSysRoleSelectedRowKeys([model.userId]);
        setDeleteTipText(trans.roleCode[Config.backLang] + ":" + model.roleCode)
        setIsDeleteFrame(true);
        setDeleteFlag("role");
    }

    const sysRoleAdd = () => {
        messageShowHandler();
        if (Base.isEmpty(roleModel.userId)) {
            errFrameShow("error", trans.saveUser[Config.backLang]);
            return;
        }
        setUserRoleModel({ defaultInd: "N", activeInd: "Y" });
        setIsRoleFrom(true);
    }

    const audit = (model, e) => {
        messageShowHandler();//清空提示信息
        e.stopPropagation();
        setAuditModel(model);
        setIsAudit(true);
    }

    const closeModal = (flag) => {
        if (flag) {
            errFrameShow("success", trans.saveSuccess[Config.backLang]);
            searchSysUserRoleList(roleModel);
        }
        setIsRoleFrom(false);
    }

    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew, "Y");
    }
    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1, "Y");
    }

    //清空列表选中
    const clearSelect = () => {
        setSelectedRowKeys([]);
        setCheckboxState([]);
    }

    const clearSysRoleSelect = () => {
        setSysRoleSelectedRowKeys([]);
        setSysRoleCheckboxState([]);
    }

    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }

    const handleChange = (e) => {
        const value = e.target.value;
        const reg = /[\u4e00-\u9fa5]/g; // 匹配汉字的正则表达式

        if (reg.test(value)) {
            form.setFieldValue('userCode', value.replace(reg, ''));
        }
    };

    const handleTableChange = (pagination, filters, sorter) => {
        let orderBy = "";
        if (sorter.field) {
            if (sorter.order === "ascend") {
                orderBy = tableColumns[sorter.field];
            } else if (sorter.order === "descend") {
                orderBy = tableColumns[sorter.field] + " DESC";
            }
        }
        if (!!sorter.field || !!searchModel.orderBy) {
            if (orderBy !== searchModel.orderBy) {
                searchModel.orderBy = orderBy;
                search(pageSize, 1, "N", true);
            }
        }
    }

    const studentAdd = () => {
        messageShowHandler();
        setIsProgrammeModal(true);
    }

    const closeProgrammeModal = (flag, list) => {
        if (flag) {
            let mergedArray = programmeTable.concat(list);
            let uniqueArray = mergedArray.reduce((acc, obj) => {
                let existingObj = acc.find(item => item.progId === obj.progId);
                if (!existingObj) {
                    acc.push(obj);
                }
                return acc;
            }, []);
            setProgrammeTable(uniqueArray)
        }
        setIsProgrammeModal(false);
    }

    const studentDelete = (index, e, model) => {
        e.stopPropagation();
        setDeleteIndex(index);
        setDeleteTipText("Programme Code" + ":" + model.progCode)
        setIsProgrammeDeleteModal(true);
    }

    const programmeDeleteClose = (state) => {
        if (state) {
            setProgrammeTable(list => {
                list.splice(deleteIndex, 1);
                return [...list];
            });
        }
        setIsProgrammeDeleteModal(false);
    }
    
    const validatePassword = async (_, value) => {
        if (!value) {
            throw new Error(trans.passwordIsNoNull[Config.backLang]);
        }
        // 密码长度至少为8位
        if (value.length < 8) {
            throw new Error(trans.passwordMin[Config.backLang]);
        }
        // 密码需要包含大写字母、小写字母、数字和特殊字符
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[()`!@#$%^&*_\-+=|{}[\]:;'<>,.?])[A-Za-z\d()`!@#$%^&*_\-+=|{}[\]:;'<>,.?]+$/;
        if (!passwordRegex.test(value)) {
            throw new Error("The Password must contain at least one uppercase letter, one lowercase letter, one digit, and one special character.");
        }
        return Promise.resolve();
    };

    const columns = [
        {
            title: trans.userId[Config.backLang],
            dataIndex: 'userId',
            className: 'tableWidth15',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'userId') },
        },
        {
            title: trans.userCode[Config.backLang],
            dataIndex: 'userCode',
            className: 'tableWidth15',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'userCode') },
        },
        {
            title: trans.userName[Config.backLang],
            dataIndex: 'userName',
            className: 'tableWidth17',
        },
        {
            title: trans.userType[Config.backLang],
            dataIndex: 'userType',
            className: 'tableWidth15',
            render: (text) => ContextHandler.getMapValue('userTypeMap', text)
        },
        {
            title: trans.email[Config.backLang],
            dataIndex: 'email',
            className: 'tableWidth25',
        },
        {
            title: trans.activeInd[Config.backLang],
            dataIndex: 'activeInd',
            className: 'tableWidth9',
            render: (text) => ContextHandler.getMapValueTransalation('activeMapTransalation', text)
        },
        {
            title: trans.controls[Config.backLang],
            dataIndex: '',
            width: 275,
            className: ' sysControls',
            fixed: 'right',
            render: (text, record) => <div className='operation'>
                {(!record.userType || record.userType === "ADMIN") && <div className='sysUpdate' hidden={Config.funcInfo.canUpdate === "N"} onClick={(e) => update(record, e)}><EditOutlined /> {trans.update[Config.backLang]}</div>}
                <div className='sysView' onClick={(e) => view(record, e)} ><SearchOutlined /> {trans.view[Config.backLang]}</div>
                {(!record.userType || record.userType === "ADMIN") && <div className='sysDelete' hidden={Config.funcInfo.canDelete === "N"} onClick={(e) => deleteOne(record, e)}><DeleteOutlined /> {trans.delete[Config.backLang]}</div>}
                <div className='sysLogs' onClick={(e) => audit(record, e)}><EyeOutlined /> {trans.audit[Config.backLang]}</div>
            </div>
        },
    ];

    const sysRoleColumns = [
        {
            title: trans.roleCode[Config.backLang],
            dataIndex: 'roleCode',
            className: "tableWidth27",
        },
        {
            title: trans.roleName[Config.backLang],
            dataIndex: 'roleName',
            className: "tableWidth27",
        },
        {
            title: trans.defaultInd[Config.backLang],
            dataIndex: 'defaultInd',
            className: "tableWidth22",
            render: (text) => ContextHandler.getMapValueTransalation('indsTransalation', text)
            // render: (text) => ContextHandler.getIndValue(text)
        },
        {
            title: trans.jHActiveInd[Config.backLang],
            dataIndex: 'activeInd',
            className: "tableWidth22",
            render: (text) => ContextHandler.getMapValueTransalation('indsTransalation', text)
            // render: (text) => ContextHandler.getIndValue(text)
        },
        {
            title: trans.controls[Config.backLang],
            dataIndex: '',
            width: 206,
            className: ' sysControls',
            fixed: 'right',
            render: (text, record) => <div className='operation'>
                {flag === "edit" && <>
                    <div className='sysUpdate' onClick={(e) => sysRoleEdit(record, e)}><EditOutlined /> {trans.update[Config.backLang]}</div>
                    <div className='sysDelete' onClick={(e) => sysRoleDelete(record, e)}><DeleteOutlined /> {trans.delete[Config.backLang]}</div>
                </>}
                <div className='sysLogs' onClick={(e) => audit(record, e)}><EyeOutlined /> {trans.audit[Config.backLang]}</div>
            </div>
        },
    ]

    const columnsTwo = [
        {
            title: trans.progCode[Config.backLang],
            dataIndex: 'progCode',
            className: 'tableWidth20',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'progCode') },
        },
        {
            title: trans.progTitle[Config.backLang],
            dataIndex: 'progTitle',
            className: 'tableWidth30',
        },
        {
            title: trans.progLaunchYear[Config.backLang],
            dataIndex: 'progLaunchYear',
            className: 'tableWidth15',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'progLaunchYear') },
        },
        {
            title: 'Department',
            dataIndex: 'deptId',
            className: 'tableWidth35',
            render: text => deptList.map(item => item.deptId === text && item.deptCode + '-' + item.deptDisplayName)
        },
        // {
        //     title: trans.controls[Config.backLang],
        //     dataIndex: '',
        //     width: 90,
        //     className: ' sysControls',
        //     fixed: 'right',
        //     render: (text, record, index) => <div className='operation'>
        //         {flag != 'view' && <div className='sysDelete' onClick={(e) => studentDelete(index, e, record)}><DeleteOutlined /> {trans.delete[Config.backLang]}</div>}
        //     </div>
        // },
    ]

    return (
        <div id="container" className="template sysUser">
            <div className='breadcrumb'>
                <HomeOutlined /> / {trans.sysManage[Config.backLang]} / <span className='breadcrumbTitle'>{Config.funcInfo['funcName' + (Config.backLang === 'TC' ? 'Tc' : (Config.backLang === 'EN' ? 'En' : ''))]}</span>
            </div>
            {/* 错误信息弹框 */}
            <Message ref={messageRef} />
            <div className='templateMain'>
                <Spin size="large" spinning={isLoad} tip={spinInfo}>
                    {/* 审核彈框 */}
                    <Audit visible={isAudit} auditModel={auditModel} close={auditCancel} />
                    {/* 删除弹框 */}
                    {isDeleteFrame ? <PopupFrame close={deleteFrameClose} deleteTipText={deleteTipText} /> : null}
                    {isProgrammeDeleteModal ? <PopupFrame close={programmeDeleteClose} deleteTipText={deleteTipText} /> : null}
                    <Tabs activeKey={tabIndex} onChange={(e) => handleSelect(e)}>
                        <TabPane key="1" tab={trans.list[Config.backLang]}>
                            <div className='sysRow'>
                                <div className='sysCol'>
                                    <div className="sysTitles">{trans.userId[Config.backLang]}</div>
                                    <div className="sysSerchInput">
                                        <Input placeholder={trans.userId[Config.backLang]} value={searchModel.userIds}
                                            onChange={(e) => searchChange('userIds', e.target.value)}
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null} />
                                    </div>
                                </div>
                                <div className='sysCol'>
                                    <div className="sysTitles">{trans.userCode[Config.backLang]}</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" placeholder={trans.userCode[Config.backLang]}
                                            onChange={(e) => searchChange('userCode', e.target.value)}
                                            value={searchModel.userCode || ''}
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null} />
                                    </div>
                                </div>
                                <div className='sysCol'>
                                    <div className="sysTitles">{trans.userName[Config.backLang]}</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" placeholder={trans.userName[Config.backLang]}
                                            onChange={(e) => searchChange('userName', e.target.value)}
                                            value={searchModel.userName || ''}
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null} />
                                    </div>
                                </div>
                                <div className='sysCol'>
                                    <div className="sysTitles">{trans.userType[Config.backLang]}</div>
                                    <div className="sysSerchInput">
                                        <Select placeholder={trans.userType[Config.backLang]} value={searchModel.userType}
                                            className="sysSelect"
                                            onChange={(e) => searchChange('userType', e)}>
                                            <Option value=""></Option>
                                            {context.userTypeMap.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                        </Select>
                                    </div>
                                </div>
                                <div className='sysSearchButton'>
                                    <Button className="sysBtn btnBlue" type="primary" onClick={() => search(pageSize, 1, "N", true)} hidden={Config.funcInfo.canSelect === "N"} icon={<SearchOutlined />}>{trans.search[Config.backLang]}</Button>
                                    <Button className="sysBtn" onClick={reset} icon={<RedoOutlined />} >{trans.reset[Config.backLang]}</Button>
                                </div>
                            </div>

                            <div className="sysLineEight" />
                            <Space size={[5, 5]} wrap className="buttonRelative">
                                <Button className="sysBtn btnBlue" type="primary" onClick={add} hidden={Config.funcInfo.canInsert === "N"} icon={<PlusCircleOutlined />}>{trans.add[Config.backLang]}</Button>
                            </Space>
                            <div className="sysTable" id="tableOne">
                                <Table
                                    scroll={{ x: 1200 }}
                                    rowKey="userId" //Key值
                                    columns={columns} //列名
                                    dataSource={tables} //数据
                                    pagination={{  //分页
                                        showSizeChanger: true,                      //是否显示可以设置几条一页的选项
                                        onChange: onChange,                  //上页下页或者跳页方法
                                        onShowSizeChange: onShowSizeChange,          //每页显示条数方法
                                        total: tablesCount,        //总共多少条数据
                                        current: current,       //当前页
                                        pageSize: pageSize,  //每页显示多少条数据
                                        defaultCurrent: 1,                           //默认当前页为1
                                        size: "small"
                                    }}
                                    onChange={handleTableChange}
                                />
                            </div>
                        </TabPane>
                        <TabPane key="2" tab={trans.user[Config.backLang]} forceRender={true}>
                            <Form form={form} onFinish={onFinish}>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">{trans.userId[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="userId"
                                            >
                                                <Input type="text" placeholder={trans.userId[Config.backLang]} maxLength={20} disabled />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="redSize">{trans.lookOut[Config.backLang]}</div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">{trans.userCode[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="userCode"
                                                rules={[
                                                    { required: true, message: trans.userCodeIsNoNull[Config.backLang] },
                                                ]}
                                            >
                                                <Input type="text" placeholder={trans.userCode[Config.backLang]} maxLength={100} onChange={handleChange} disabled={flag !== "add"} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">{trans.userName[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="userName"
                                                rules={[
                                                    { required: true, message: trans.userNameIsNoNull[Config.backLang] },
                                                ]}
                                            >
                                                <Input type="text" placeholder={trans.userName[Config.backLang]} maxLength={150} disabled={flag === "view"} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                {flag === "add" ?
                                    <div className='sysRow'>
                                        <div className='sysCol'>
                                            <div className="sysParam mustFill">{trans.password[Config.backLang]}</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="pwd"
                                                    rules={[
                                                        { validator: validatePassword }
                                                    ]}
                                                >
                                                    <Input type="password" placeholder={trans.password[Config.backLang]} maxLength={20} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className='sysCol'>
                                            <div className="sysParam">{trans.email[Config.backLang]}</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="email"
                                                    rules={[
                                                        { required: false },
                                                        { pattern: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/, message: trans.incorrectEmailFormat[Config.backLang] },
                                                    ]}
                                                >
                                                    <Input type="text" placeholder={trans.email[Config.backLang]} maxLength={50} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    : null}
                                <div className='sysRow'>
                                    {/* <div className='sysCol'>
                                        <div className="sysParam mustFill">{trans.phone[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="phone"
                                                rules={[
                                                    { required: true, validator: (rule, value) => checkPhone(value) },
                                                ]}
                                                getValueFromEvent={(e) => e.target.value.replace(/\D/g, '')}
                                            >
                                                <Input type="text" placeholder={trans.phone[Config.backLang]} maxLength={11} />
                                            </Form.Item>
                                        </div>
                                    </div> */}
                                    {flag !== "add" ?
                                        <div className='sysCol'>
                                            <div className="sysParam">{trans.email[Config.backLang]}</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="email"
                                                    rules={[
                                                        { required: false },
                                                        { pattern: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/, message: trans.incorrectEmailFormat[Config.backLang] },
                                                    ]}
                                                >
                                                    <Input type="text" placeholder={trans.email[Config.backLang]} maxLength={250} disabled={flag === "view"} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        : null}
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">{trans.activeInd[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="activeInd"
                                                rules={[
                                                    { required: true, message: trans.activeIndIsNoNull[Config.backLang] },
                                                ]}
                                            >
                                                <Select className="sysSelect" disabled={flag === "view"}>
                                                    <Option value=""></Option>
                                                    {context.activeMapTransalation.map((item) => <Option key={item.value} value={item.value}>{item[Config.backLang]}</Option>)}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                {flag === 'add' ?
                                    <div className='sysRow'>
                                        <div className='sysCol'>
                                            <div className="sysParam mustFill">{trans.userType[Config.backLang]}</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="userType"
                                                >
                                                    <Select className="sysSelect" >
                                                        <Option value=""></Option>
                                                        {context.userTypeAddMap.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                                    </Select>
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    <div className='sysRow'>
                                        <div className='sysCol'>
                                            <div className="sysParam mustFill">{trans.userType[Config.backLang]}</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="userType"
                                                >
                                                    <Select className="sysSelect" disabled>
                                                        <Option value=""></Option>
                                                        {context.userTypeMap.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                                    </Select>
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                }
                                {userType === 'LITE_ADMIN' &&
                                    <>
                                        <div className="sysBodyRow">
                                            <div className="userRoleTitleRow">Programme</div>
                                            <div className="sysBodyRow">
                                                {(flag == "add" || flag == "edit") && <Button className="sysBtnTwo btnBlue" type="primary" hidden={Config.funcInfo.canInsert === "N"} onClick={studentAdd} icon={<PlusCircleOutlined />} >{trans.add[Config.backLang]}</Button>}
                                            </div>
                                        </div>
                                        <div className="sysTable" id="tableOne">
                                            <Table
                                                scroll={{ x: 1200 }}
                                                rowKey="assignToUserId" //Key值
                                                columns={columnsTwo} //列名
                                                dataSource={programmeTable} //数据
                                                pagination={false}
                                            />
                                        </div>
                                    </>
                                }
                                <div className="sysSaveButton">
                                    {flag !== "view" && <Button className="sysBtn btnBlue" type="primary" disabled={isLoad} icon={<CheckCircleOutlined />} htmlType="submit" >{trans.save[Config.backLang]}</Button>}
                                    <Button className="sysBtn" icon={<CloseCircleOutlined />} onClick={cancel}>{trans.cancel[Config.backLang]}</Button>
                                </div>
                            </Form>
                            {flag !== "add" && roleModel.userType !== "ACADEMIC" && <>
                                <div className="sysBodyRow">
                                    <div className="userRoleTitleRow">{trans.role[Config.backLang]}</div>
                                    <div className="sysBodyRow">
                                        {flag === "edit" && <Button className="sysBtnTwo btnBlue" type="primary" hidden={Config.funcInfo.canInsert === "N"} onClick={sysRoleAdd} icon={<PlusCircleOutlined />} >{trans.add[Config.backLang]}</Button>}
                                    </div>
                                </div>
                                <div className="packing-table " id="tableOne">
                                    <Table
                                        scroll={{ x: 1200 }}
                                        rowKey="userRoleId" //Key值
                                        columns={sysRoleColumns} //列名
                                        dataSource={sysUserRoleList} //数据
                                        pagination={false}
                                        onRow={(record) => {
                                            return {
                                                onClick: event => Base.selectRadioRowNew.call(this, record, 'userRoleId', sysRoleSelectedRowKeys, setSysRoleCheckboxState, setSysRoleSelectedRowKeys),
                                            };
                                        }}
                                    />
                                </div>
                            </>}
                        </TabPane>
                        {/* <TabPane key="3" tab={trans.bindDocId[Config.backLang]} forceRender={true}>
                            <Form form={form2} onFinish={onFinish2}>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">{trans.userAccount[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="userId"
                                            >
                                                <Input type="text" placeholder={trans.userAccount[Config.backLang]} disabled />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam">{trans.userName[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="userName"
                                                rules={[
                                                    { required: true, message: trans.userNameIsNoNull[Config.backLang] },
                                                ]}
                                            >
                                                <Input type="text" placeholder={trans.userName[Config.backLang]} disabled />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam">{trans.realName[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="realName"
                                                rules={[
                                                    { required: false, message: trans.realNameIsNoNull[Config.backLang] },
                                                ]}
                                            >
                                                <Input type="text" placeholder={trans.realName[Config.backLang]} maxLength={50} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam">{trans.docId[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="docId"
                                                rules={[
                                                    { required: true, validator: (rule, value) => checkIdCardNo(value) }
                                                ]}
                                            >
                                                <Input type="text" placeholder={trans.docId[Config.backLang]} maxLength={20} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className="sysSaveButton">
                                    <Button className="sysBtn btnBlue" type="primary" disabled={isLoad} icon={<CheckCircleOutlined />} htmlType="submit">{trans.save[Config.backLang]}</Button>
                                    <Button className="sysBtn" icon={<CloseCircleOutlined />} onClick={cancel}>{trans.cancel[Config.backLang]}</Button>
                                </div>
                            </Form>
                        </TabPane> */}
                    </Tabs>
                </Spin>
            </div>
            {/* 用户的角色添加编辑弹框 */}
            {isRoleFrom ? <RoleFromModal onClose={closeModal} phone={roleModel.phone} userId={roleModel.userId} model={userRoleModel} /> : null}
            {/* 用户指定Programme弹窗 */}
            {isProgrammeModal && <SelectProgrammeModal onClose={closeProgrammeModal} checkboxState={programmeTable ?? []} />}
        </div >
    )

}

export default SysUser;